import { PluginListenerHandle, registerPlugin } from '@capacitor/core'

export type SMSPermissionResult = {
  granted: boolean
}

export type SMSMessage = {
  message: string
}

export type SMSReaderListeners = {
  smsReceived: (data: SMSMessage) => void
}

export type SMSReaderPlugin = {
  checkPermissions(): Promise<SMSPermissionResult>
  requestPermissions(): Promise<SMSPermissionResult>
  startSMSListener(): Promise<void>
  stopSMSListener(): Promise<void>
  addListener(
    eventName: keyof SMSReaderListeners,
    listenerFunc: SMSReaderListeners[keyof SMSReaderListeners],
  ): Promise<PluginListenerHandle>
  removeAllListeners(): Promise<void>
}

const SMSReader = registerPlugin<SMSReaderPlugin>('SMSReader')

export default SMSReader
